import styled from '@emotion/styled/macro';
import { Card, forPhoneOnly, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { Link } from 'react-router-dom';

export const PatientOverviewCard = styled(Card)`
    display: flex;
    flex-direction: column;
    flex: 1 1;

    & > *:not(:last-child) {
        margin-bottom: 16px;
    }

    ${forPhoneOnly(`
        display: block;
    `)};
`;
export const Loading = styled.div`
    margin: 20px 0;
`;

export const TopRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    & > *:first-of-type {
        margin-right: 16px;
    }
`;
export const Title = styled.div`
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: ${Variables.Colors.p500};
`;

export const RecordRow = styled.div`
    display: flex;
    font-size: 14px;
    color: ${Variables.Colors.n50};
    & > *:not(:first-of-type) {
        margin-left: 4px;
    }
`;
export const RecordLabel = styled.div`
    font-weight: 500;
`;
export const RecordNumber = styled.div`
    letter-spacing: 0.5px;
`;

export const PatientRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    & > *:not(:last-child) {
        margin-right: 8px;
    }
`;
export const PatientName = styled.div`
    font-size: 24px;
    color: ${Variables.Colors.n100};
`;
export const PatientDivider = styled.span`
    font-size: 24px;
    color: ${Variables.Colors.n100};
`;
export const MemberLabel = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;
export const MemberId = styled.div`
    font-size: 16px;
    letter-spacing: 0.5px;
    color: ${Variables.Colors.b300};
`;

export const IconRow = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    color: ${Variables.Colors.n85};
    margin-top: 8px;
`;
export const BaseIcon = styled(Icon)`
    height: 24px;
    width: 24px;
    border-radius: 24px;

    fill: ${Variables.Colors.white};
    background-color: ${Variables.Colors.n85};

    margin-right: 8px;

    &:not(:first-of-type) {
        margin-left: 16px;
    }
`;
export const DobIcon = styled(BaseIcon)`
    padding: 3px 0px;
`;
export const PatientIcon = styled(BaseIcon)`
    padding: 1px 0 2px 0;
`;
export const WeightIcon = styled(BaseIcon)`
    padding: 1px 0 2px 0;
`;
export const AddressIcon = styled(BaseIcon)`
    padding: 4px 0;
`;

export const PhoneIcon = styled(BaseIcon)`
    padding: 1px 0 2px 0;
`;

export const FooterRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0;

    &:not(:first-of-type) {
        margin-top: 24px;
    }

    &:last-child {
        justify-content: flex-end;
    }
`;

export const FooterLink = styled(Link)`
    text-align: right;
    font-size: 16px;
    line-height: 1;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.p200};
    cursor: pointer;
`;

export const OverviewWrapper = styled.div`
    display: flex;
`;

export const Column = styled.div``;
